import { assets } from "./site";

// Combo Meals — top-selling combos, ordered low → high price.
// Photos: 4 provided; 2 (two-curry & shaan-combos) use temporary images until supplied.
const COMBO_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_curry-house-menu-3/artifacts";
export const combos = [
  {
    name: "Quick Meals",
    includes: "1 Curry + Rice or Naan + Salad",
    priceVeg: "$14.99",
    priceNonVeg: "$16.99",
    image: `${COMBO_IMG}/l2q8wu33_Quick%20Meals.webp`,
  },
  {
    name: "Samosa Delights",
    includes: "1 Curry + 1 Veg Samosa + Rice or Naan",
    priceVeg: "$14.99",
    priceNonVeg: "$16.99",
    image: `${COMBO_IMG}/lzfhened_Samosa%20Delights.webp`,
  },
  {
    name: "Two-Curry Specials",
    includes: "2 Curries + Rice or Naan",
    price: "$17.99",
    image: `${COMBO_IMG}/1wwk0p1q_Two-Curry.jpeg`,
  },
  {
    name: "House Specials",
    includes: "1 Curry + Rice + Naan + Salad + Drink",
    price: "$18.99",
    image: `${COMBO_IMG}/z8h2qqg4_House%20Specials.webp`,
  },
  {
    name: "Big Meals",
    includes: "2 Curries + Rice + Naan + Salad",
    price: "$20.99",
    image: `${COMBO_IMG}/1hoj5twy_Big%20Meals.webp`,
  },
  {
    name: "Shaan Curry Combos",
    includes: "1 Curry + Samosa + Rice + Naan + Salad + Drink",
    price: "$21.99",
    image: `${COMBO_IMG}/teq3uj9i_Shaan%20Curry%20Combo.webp`,
  },
];

// Every combo lets you choose your curry from these options.
export const comboCurries = {
  veg: ["Vegetable Curry", "Chickpea Curry", "Lentil Curry", "Paneer Makhni"],
  nonVeg: ["Chicken Curry", "Butter Chicken", "Beef Curry", "Lamb Curry", "Fish Curry", "Tandoori Chicken"],
};

// A la carte menu grouped by category.
// tags: veg | nonveg | vegan | spicy  (veg/nonveg drive the coloured dot)
// Ordered veg-first then non-veg, cheapest-first (sorted at render time).
export const alacarte = [
  {
    category: "Street Food & Chaat",
    short: "Street Food",
    slug: "street-food",
    note: "India's beloved street snacks — crunchy, tangy and fun to share.",
    items: [
      { name: "Pani Puri", desc: "Crispy hollow puffs you fill with spiced tangy water, potato & chickpeas.", price: "$12.50", tags: ["veg", "vegan"] },
      { name: "Bhel Puri", desc: "Puffed rice tossed with onion, tomato, tangy chutneys & crunchy sev.", price: "$12.99", tags: ["veg", "vegan"] },
      { name: "Chaat Papdi", desc: "Crispy wafers layered with potato, chickpeas, yogurt & sweet-tangy chutneys.", price: "$12.99", tags: ["veg"] },
      { name: "Samosa Chaat", desc: "Crushed samosa topped with chickpea curry, cool yogurt & chutneys.", price: "$12.99", tags: ["veg"] },
      { name: "Aloo Tikki", desc: "Golden pan-fried spiced potato patties served with chutneys.", price: "$12.99", tags: ["veg"] },
      { name: "Dahi Bhalla Chaat", desc: "Soft lentil dumplings in cool yogurt with sweet & tangy chutneys.", price: "$13.99", tags: ["veg"] },
    ],
  },
  {
    category: "Snacks, Appetizers & Platter",
    short: "Snacks",
    slug: "snacks",
    note: "Crispy, savoury starters to begin the meal.",
    items: [
      { name: "Samosas (1 pc)", desc: "Crispy pastry triangle filled with spiced potato & peas — veg or chicken.", price: "$2.99", tags: ["veg", "nonveg"] },
      { name: "Hara Bhara Kebab (1 pc)", desc: "Pan-fried patties of spinach, green peas & potato.", price: "$4.99", tags: ["veg"] },
      { name: "Stuffed Bread Pakora", desc: "Bread stuffed with spiced potato, dipped in chickpea batter & fried.", price: "$7.99", tags: ["veg"] },
      { name: "Onion Bhaji (1 pc)", desc: "Crispy chickpea-battered onion fritters.", price: "$9.99", tags: ["veg", "vegan"] },
      { name: "Amritsari Kulcha Platter", desc: "Stuffed baked flatbread served with curry & sides.", price: "$14.99", tags: ["veg"] },
    ],
  },
  {
    category: "Indian Special Curries",
    short: "Curries",
    slug: "curries",
    portion: "Large (24oz)",
    note: "Our rich, simmered classics. Vegetarian dishes are listed first in each group.",
    subgroups: [
      {
        label: "Paneer",
        items: [
          { name: "Matar Paneer", desc: "Cottage cheese & green peas in a spiced tomato sauce.", price: "$19.99", tags: ["veg"] },
          { name: "Kadhai Paneer", desc: "Cottage cheese with peppers & onions in a bold tomato masala.", price: "$21.99", tags: ["veg"] },
        ],
      },
      {
        label: "Korma",
        items: [
          { name: "Vegetable Korma", desc: "Mixed vegetables in a mild, creamy cashew sauce.", price: "$20.99", tags: ["veg"] },
          { name: "Chicken Korma", desc: "Chicken in a mild, creamy cashew sauce.", price: "$22.99", tags: ["nonveg"] },
          { name: "Beef Korma", desc: "Tender beef in a rich, mild creamy sauce.", price: "$24.99", tags: ["nonveg"] },
          { name: "Lamb Korma", desc: "Slow-cooked lamb in a mild, creamy sauce.", price: "$24.99", tags: ["nonveg"] },
        ],
      },
      {
        label: "Saag",
        items: [
          { name: "Saag Aloo", desc: "Soft potatoes simmered in creamy spiced spinach.", price: "$18.99", tags: ["veg", "vegan"] },
          { name: "Saag Paneer", desc: "Cottage cheese in a creamy spiced spinach sauce.", price: "$21.99", tags: ["veg"] },
          { name: "Saag Lamb", desc: "Tender lamb simmered in creamy spiced spinach.", price: "$24.99", tags: ["nonveg"] },
          { name: "Saag Beef", desc: "Beef simmered in creamy spiced spinach.", price: "$24.99", tags: ["nonveg"] },
        ],
      },
      {
        label: "Makhani",
        items: [
          { name: "Dal Makhani", desc: "Black lentils slow-cooked with butter & cream.", price: "$19.99", tags: ["veg"] },
          { name: "Paneer Makhani", desc: "Cottage cheese in a silky, buttery tomato-cream sauce.", price: "$21.99", tags: ["veg"] },
        ],
      },
      {
        label: "Curry",
        items: [
          { name: "Lentil Curry", desc: "Comforting simmered lentils (dal) with garlic & spices.", price: "$18.99", tags: ["veg", "vegan"] },
          { name: "Chickpea Curry", desc: "Chickpeas in a tangy onion-tomato masala (chana masala).", price: "$18.99", tags: ["veg", "vegan"] },
          { name: "Vegetable Curry", desc: "Mixed vegetables in a homestyle spiced gravy.", price: "$20.99", tags: ["veg", "vegan"] },
          { name: "Fish Curry", desc: "Fish in a tangy, spiced curry sauce.", price: "$22.99", tags: ["nonveg", "spicy"] },
          { name: "Chicken Curry", desc: "Classic chicken curry in a spiced gravy.", price: "$22.99", tags: ["nonveg", "spicy"] },
          { name: "Lamb Curry", desc: "Lamb simmered in a rich, spiced gravy.", price: "$22.99", tags: ["nonveg", "spicy"] },
          { name: "Beef Curry", desc: "Beef simmered in a rich, spiced gravy.", price: "$23.99", tags: ["nonveg", "spicy"] },
        ],
      },
    ],
  },
  {
    category: "Indo-Chinese & Momos",
    short: "Indo-Chinese & Momos",
    slug: "indo-chinese",
    note: "Indian-style Chinese favourites and dumplings — bold, saucy and fun.",
    subgroups: [
      {
        label: "Momos / Dumplings",
        items: [
          { name: "Veg Steam Momos", desc: "Steamed dumplings filled with spiced vegetables.", price: "$11.99", tags: ["veg"] },
          { name: "Veg Fried Momos", desc: "Crispy fried vegetable dumplings.", price: "$12.99", tags: ["veg"] },
          { name: "Paneer Steam Momos", desc: "Steamed dumplings filled with spiced cottage cheese.", price: "$12.99", tags: ["veg"] },
          { name: "Paneer Fried Momos", desc: "Crispy fried cottage-cheese dumplings.", price: "$13.99", tags: ["veg"] },
          { name: "Veg Momo Manchurian", desc: "Veg dumplings tossed in a spicy Indo-Chinese sauce.", price: "$16.99", tags: ["veg", "spicy"] },
          { name: "Paneer Momo Manchurian", desc: "Paneer dumplings tossed in a spicy Indo-Chinese sauce.", price: "$17.99", tags: ["veg", "spicy"] },
          { name: "Chicken Steam Momos", desc: "Steamed dumplings filled with spiced chicken.", price: "$12.99", tags: ["nonveg"] },
          { name: "Chicken Fried Momos", desc: "Crispy fried chicken dumplings.", price: "$13.99", tags: ["nonveg"] },
          { name: "Chicken Momo Manchurian", desc: "Chicken dumplings tossed in a spicy Indo-Chinese sauce.", price: "$17.99", tags: ["nonveg", "spicy"] },
        ],
      },
      {
        label: "Indo-Chinese Specials",
        items: [
          { name: "Veg Fried Rice", desc: "Wok-tossed rice with vegetables.", price: "$12.99", tags: ["veg", "vegan"] },
          { name: "Veg Noodles", desc: "Stir-fried noodles with vegetables.", price: "$12.99", tags: ["veg", "vegan"] },
          { name: "Veg Manchurian", desc: "Fried vegetable balls in a tangy-spicy soy sauce.", price: "$17.99", tags: ["veg", "spicy"] },
          { name: "Chilli Paneer", desc: "Cottage cheese tossed with peppers in a spicy sauce.", price: "$19.99", tags: ["veg", "spicy"] },
          { name: "Paneer Manchurian", desc: "Cottage cheese in a tangy-spicy Indo-Chinese sauce.", price: "$19.99", tags: ["veg", "spicy"] },
          { name: "Chilli Chicken", desc: "Crispy chicken tossed with peppers in a spicy sauce.", price: "$21.99", tags: ["nonveg", "spicy"] },
          { name: "Chicken Manchurian", desc: "Chicken in a tangy-spicy soy-garlic sauce.", price: "$21.99", tags: ["nonveg", "spicy"] },
        ],
      },
    ],
  },
  {
    category: "Biryani Specials",
    short: "Biryani",
    slug: "biryani",
    note: "Fragrant basmati rice slow-cooked with spices, layer by layer.",
    items: [
      { name: "Vegetable Biryani", desc: "Basmati rice layered with spiced mixed vegetables.", price: "$14.99", tags: ["veg"] },
      { name: "Bombay Chicken Biryani", desc: "Aromatic rice slow-cooked with spiced chicken.", price: "$15.99", tags: ["nonveg", "spicy"] },
      { name: "Lamb Biryani", desc: "Basmati rice layered with tender spiced lamb.", price: "$16.99", tags: ["nonveg", "spicy"] },
      { name: "Beef Biryani", desc: "Basmati rice slow-cooked with spiced beef.", price: "$16.99", tags: ["nonveg", "spicy"] },
    ],
  },
  {
    category: "Tandoori Specials",
    short: "Tandoori",
    slug: "tandoori",
    note: "Marinated and roasted in a traditional clay oven.",
    items: [
      { name: "Tandoori Chicken (pieces)", desc: "Yogurt-&-spice marinated chicken roasted in the tandoor.", price: "$6.99", tags: ["nonveg", "spicy"] },
    ],
  },
  {
    category: "Breads, Rice & Extras",
    short: "Breads & Rice",
    slug: "breads",
    note: "The perfect companions to any curry.",
    items: [
      { name: "Papadum", desc: "Thin, crispy lentil crackers.", price: "$0.99", tags: ["veg", "vegan"] },
      { name: "Sauces", desc: "House chutneys & dipping sauces.", price: "$0.99", tags: ["veg"] },
      { name: "Roti", desc: "Whole-wheat flatbread baked fresh.", price: "$1.25", tags: ["veg", "vegan"] },
      { name: "Naan", desc: "Soft, fluffy leavened flatbread.", price: "$2.99", tags: ["veg"] },
      { name: "Garlic Naan", desc: "Naan brushed with garlic & butter.", price: "$3.99", tags: ["veg"] },
      { name: "Basmati Rice", desc: "Steamed fragrant long-grain rice.", price: "$6.99", tags: ["veg", "vegan"] },
      { name: "Salad", desc: "Fresh garden salad.", price: "$6.99", tags: ["veg", "vegan"] },
    ],
  },
  {
    category: "Family Specials",
    short: "Family Specials",
    slug: "family-specials",
    note: "Complete dinner sets built to share — curry, lentils, rice, naan, samosa, dessert & our signature sauces. Choose Veg or Non-Veg curries.",
    items: [
      { name: "Dinner for 1", desc: "1 choice of curry (Veg or Non-Veg), lentils, rice, salad, 1 naan, 1 samosa, 1 gulab jamun, signature sauces & green chutney.", price: "$25.99", tags: ["veg", "nonveg"] },
      { name: "Dinner for 2", desc: "2 choices of curry (Veg or Non-Veg), lentils, rice, salad, 2 naan, 2 samosa, 2 gulab jamun, signature sauces & green chutney.", price: "$45.99", tags: ["veg", "nonveg"] },
      { name: "Dinner for 4", desc: "3 Veg (small) & 2 Non-Veg (large) curries, lentils, rice, salad, 4 naan, 4 samosa, 4 gulab jamun, signature sauces & green chutney.", price: "$85.99", tags: ["veg", "nonveg"] },
      { name: "Dinner for 6", desc: "3 Veg (large) & 2 Non-Veg (large) curries, lentils, rice, salad, 6 naan, 6 samosa, 6 gulab jamun, signature sauces & green chutney.", price: "$116.99", tags: ["veg", "nonveg"] },
    ],
  },
];

// Catering packages — mirrors the attached flyer
export const cateringTiers = [
  {
    name: "Family Celebration",
    price: "$14.99",
    per: "per person",
    for: "Ideal for house warmings, birthday parties & small gatherings",
    accent: "green",
    highlight: false,
    sections: [
      { label: "Starter (Choose Any 1)", items: ["1 Vegetarian"] },
      { label: "Main Course (Choose Any 3)", items: ["2 Vegetarian (Dal & Channa/Rajama)", "1 Paneer Dish"] },
      { label: "Includes", items: ["Steamed Rice", "Naan / Tawa Roti"] },
      { label: "Dessert (Choose Any 1)", items: ["Gulab Jamun"] },
    ],
  },
  {
    name: "Festive Gathering",
    price: "$19.99",
    per: "per person",
    for: "Perfect for baby showers, anniversaries & medium-sized functions",
    accent: "red",
    highlight: true,
    sections: [
      { label: "Starters (Choose Any 2)", items: ["1 Vegetarian", "1 Non-Vegetarian (Chicken)"] },
      { label: "Main Course (Choose Any 3)", items: ["1 Vegetarian (Dal/Chana/Rajama)", "1 Vegetarian (Paneer / Mix Veg)", "1 Non-Vegetarian (Chicken)"] },
      { label: "Includes", items: ["Steamed Rice", "Fresh Salad", "Tawa Roti, Naan, Garlic Naan"] },
      { label: "Dessert (Choose Any 1)", items: ["Gulab Jamun"] },
    ],
  },
  {
    name: "Grand Celebration",
    price: "$24.99",
    per: "per person",
    for: "Best suited for engagements & wedding-related functions",
    accent: "purple",
    highlight: false,
    sections: [
      { label: "Starters (Choose Any 4)", items: ["2 Vegetarian", "2 Non-Vegetarian (Chicken & Lamb)"] },
      { label: "Main Course (Choose Any 4)", items: ["2 Vegetarian", "2 Non-Vegetarian (Chicken & Lamb)"] },
      { label: "Includes", items: ["Steamed Rice", "Naan, Garlic Naan", "Fresh Salad & Green Salad"] },
      { label: "Dessert (Choose Any 1)", items: ["Gulab Jamun"] },
    ],
  },
];

export const cateringOccasions = [
  "Birthday Parties",
  "Baby Showers",
  "Anniversaries",
  "Engagements",
  "Weddings",
  "Corporate Events",
];
